import { Component, OnInit, AfterViewInit,HostListener, ViewChild, TemplateRef, ViewContainerRef, ViewChildren, QueryList, ChangeDetectorRef} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { MainCampaignActions } from "./main-campaign.actions";
import * as $ from "jquery";
import { GlobalService } from "../global.service";

@Component({
  selector: 'app-main-campaign',
  templateUrl: './main-campaign.component.html',
  styleUrls: ['./main-campaign.component.scss']
})
export class MainCampaignComponent implements OnInit {

  step:any = 1;
  option:any;
  subscription:any;
  goToStep3:any;
  dfOption:any;
  options: string[] = ["newLine", "portIn", "changePlan"];
  constructor(
    private store: Store<any>, 
    private globalService:GlobalService, 
    private mainCampaignActions:MainCampaignActions,
    private cd: ChangeDetectorRef
    ) {
      
   }

  ngOnInit() {

    
    if (this.globalService.getSession('viewPlan').attributes.disable_new_line === 1){
      this.options = this.options.filter(item => item !== "newLine");
    }
    if (this.globalService.getSession('viewPlan').attributes.disable_port_in === 1){
      this.options = this.options.filter(item => item !== "portIn");
    }
    if (this.globalService.getSession('viewPlan').attributes.disable_change_plan === 1){
      this.options = this.options.filter(item => item !== "changePlan");
    }
    
    // // @tam : check plan category
    // // if that is broadband (3 or 4) >> only NEW option can choose
    // var dataSession = this.globalService.getSession("mainApplication");
    // var listPlans = this.globalService.getSession("viewPlan").attributes.plans;
    // var curPlan;
    // listPlans.forEach(plan => {
    //   if(plan.id == dataSession.planId){
    //     curPlan = plan;
    //   }
    // });
    // // 1, // primary mobile
    // // 2, // supplementary mobile
    // // 3, // primary broadband
    // // 4  // supplementary broadband			
    // if(curPlan.plan_category == 3 || curPlan.plan_category == 4 ){			  

    // }

    // console.log(curPlan);


    this.dfOption = this.options[0];
    // console.log(this.dfOption);
    this.subscription = this.store.subscribe(store =>{
      this.option = store.mainCampaign.option || this.dfOption;
      this.cd.detectChanges()
    
      if(store.mainCampaign.step != this.step && this.step != 1){
        $('html, body').animate({
            scrollTop: $("#main-campaign").offset().top
        }, 500);
      }
      
      this.step = store.mainCampaign.step;

      this.goToStep3 = store.mainCampaign.goToStep3;
 
    });
    

    let mainApplication = this.globalService.getSession("mainApplication");
    // console.log(mainApplication);
    let digi_type = this.globalService.getSession('digi_type')
    if(digi_type == 'broad_type'){
      this.store.dispatch(this.mainCampaignActions.updateStep1({
        acountNo: "",
        network: "",
        phone: "",
        phoneId: "",
        phoneId_number: "",
        typeOfNumber: "",
      }));
      this.store.dispatch(this.mainCampaignActions.updateStep2({
        device: [],
        plan: [],
        services:[]
      }));  
      this.store.dispatch(this.mainCampaignActions.updateOption(this.dfOption))
    }else{
      this.store.dispatch(this.mainCampaignActions.stepBack());
      this.store.dispatch(this.mainCampaignActions.updateOption(this.dfOption))
    }    
  }


  ngOnDestroy(){
    this.subscription.unsubscribe();
  }
}
